export const FETCH_SHOPIFY_ORDERS = "FETCH_SHOPIFY_ORDERS";
export const CREATE_SHOPIFY_BULK = "CREATE_SHOPIFY_BULK";
export const FETCH_FEEL22_ORDERS = "FETCH_FEEL22_ORDERS";
export const CREATE_FEEL22_BULK = "CREATE_FEEL22_BULK";

export const FETCH_WOOCOMMERCE_ORDERS = "FETCH_WOOCOMMERCE_ORDERS";
